import React from "react";
import { ErrorText } from "./ErrorText";
import ReactTooltip from 'react-tooltip';

export interface FormItemProps {
    label: string | JSX.Element
    help?: string | JSX.Element
    className?: string
    srOnlyLabel?: boolean
    visible?: boolean
    errorMessage?: string
    preview?: boolean
    description?: string | JSX.Element
}

export interface FormItemPropsEx extends FormItemProps {
    inputId?: string
    required?: boolean
    children?: React.ReactNode
}

export interface FormItemState {
}

export class FormItem extends React.Component<FormItemPropsEx, FormItemState> {
    constructor(props?: FormItemPropsEx, context?: any) {
        super(props, context);

        this.state = {
        };
    }

    render() {
        let renderLabel: boolean;
        let label: JSX.Element;

        if (this.props.label) {
            if (typeof this.props.label == "string") {
                renderLabel = ((this.props.label as string).length > 0)
            }
            else
                renderLabel = true;
        }
        else
            renderLabel = false;

        if (renderLabel) {
            if (this.props.inputId) {
                label = <label htmlFor={this.props.inputId} style={{ display: this.props.srOnlyLabel ? "none" : "" }} className="form-label">
                    {this.props.required ? <span>{this.props.label}&nbsp;*</span> : this.props.label} {this.props.help ? <a className="far fa-question-circle" data-for={`${this.props.inputId}-help`} data-tip onClick={e => { e.stopPropagation(); e.preventDefault(); }}></a> : <></>}
                </label>;
            }
            else {
                label = <span style={{ display: this.props.srOnlyLabel ? "none" : "" }} className="form-label">
                    {this.props.required ? <span>{this.props.label}&nbsp;*</span> : this.props.label} {this.props.help ? <a className="far fa-question-circle" data-for={`${this.props.inputId}-help`} data-tip onClick={e => { e.stopPropagation(); e.preventDefault(); }}></a> : <></>}
                </span>;
            }
        }        

        let style: any;
        if (this.props.visible === false) {
            style = { display: "none" };
        }

        return <>
            <div style={style} className={
                `form-item` +
                `${this.props.preview ? ' form-item-preview' : ''}` +
                `${this.props.className ? (' ' + this.props.className) : ''}`
            }>
                {label}
                {this.props.description && <div className="form-item-description"><label>{this.props.description}</label></div>}
                {this.props.children}
                <ErrorText text={this.props.errorMessage} />
            </div>
            {this.props.help ? <ReactTooltip className='aus-tooltip' delayHide={500} effect='solid' getContent={tip => this.props.help} id={`${this.props.inputId}-help`} globalEventOff='click' /> : <></>}
        </>
    }
}